import React from 'react';

import css from './FormPlaceholder.module.less';

const FormPlaceholder = ({ className }) => (
  <div className={className}>
    <div className={css.long} />
    <div className={css.short} />
    <div className={css.short} />
  </div>
);

export default FormPlaceholder;



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/common/FormPlaceholer/FormPlaceholder.jsx